import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "specialisms_multiselect_modal_body" }
const _hoisted_3 = { class: "tw-mb-[24px]" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "tw-text-left tw-font-semibold !tw-shadow-none tw-w-full tw-mb-[16px]" }, " Select Services ", -1)
const _hoisted_7 = { class: "tw-flex tw-whitespace-nowrap tw-truncate" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "specialisms_multiselect_modal_search" }
const _hoisted_11 = {
  key: 0,
  class: "specialisms_multiselect_modal_inner no-scrollbar"
}
const _hoisted_12 = { class: "specialisms_multiselect_modal_item_heading" }
const _hoisted_13 = { class: "specialisms_multiselect_modal_item_title" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "specialisms_multiselect_modal_item_title_text" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 1,
  class: "tw-mx-auto tw-flex tw-justify-center"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, "Not any Services Found", -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "tw-text-left tw-font-semibold !tw-shadow-none tw-w-full tw-mt-[30px] tw-mb-[16px]" }, " Select Certificates ", -1)
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "specialisms_multiselect_modal_search" }
const _hoisted_23 = { class: "tw-mt-5" }
const _hoisted_24 = {
  key: 0,
  class: "tw-flex tw-gap-2 tw-items-center tw-pb-3 tw-border-b-solid-custom tw-px-1"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Select All")
], -1)
const _hoisted_26 = { class: "specialisms_multiselect_modal_inner specialisms_multiselect_modal_checkbox_list no-scrollbar !tw-mt-0" }
const _hoisted_27 = {
  key: 0,
  class: "tw-mx-auto tw-flex tw-justify-center"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", null, "Not any Certificate Found", -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { class: "specialisms_multiselect_modal_footer" }

import { computed, ref, onMounted } from "vue";
import { useStore } from "vuex";
import { USER_STORE } from "@/store/modules/user";
import CommonDialog from "@/core/components/CommonDialog.vue";
import { WORKSTATION } from "@/store/modules/workstation";
import CommonLoader from "@/core/components/CommonLoader.vue";
import { CERTIFICATE_STORE } from "@/store/modules/certificates";
import { displayToastMessage } from "@/core/utils/common";
import { getCurrentInstance } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkStationLinkModal',
  props: {
  phaseDetails: { type: Object, default: null },
},
  emits: [
  "onClickCloseTab",
  "onClickCancel",
  "onClickAddNewTradeSpecialism",
],
  setup(__props, { emit: __emit }) {

const props = __props;
const emits = __emit;
const internalInstance = getCurrentInstance();
const mainSelectedCategory = ref([]) as any;
const selectedSubCategory = ref([]) as any;
const panel = ref([]) as any;
const expandedPanel = ref([0]) as any;
const isLoading = ref(false);
const store = useStore();
const filterCategory = ref([]);
const filterCertificates = ref([]);
const selectAllCertificates = ref(false);
let selectedCertificate = ref([]) as any;
const user = computed(() => store.getters[`${USER_STORE}/user`]);
const activeUserWorkstation = computed(
  () => store.getters[`${WORKSTATION}/activeUserWorkstation`]
);

const listOfSpecialismsCategory = ref([]) as any;

const onClickMainCategory = (mainCategoryId: number) => {
  const isExits = mainSelectedCategory.value.find(
    (cat: any) => cat?.id === mainCategoryId
  );
  if (isExits) {
    const mainCategory = listOfSpecialismsCategory.value.find(
      (category: any) => category?.id === mainCategoryId
    );
    mainCategory.subCategories.forEach((element: any) => {
      const elementIndex = selectedSubCategory.value.findIndex(
        (subCategory: any) => subCategory === element.id
      );
      if (elementIndex > -1) {
        selectedSubCategory.value.splice(elementIndex, 1);
      }
    });
  } else {
    const mainCategory = listOfSpecialismsCategory.value.find(
      (category: any) => category?.id === mainCategoryId
    );

    mainCategory.subCategories.forEach((element: any) => {
      if (!selectedSubCategory.value.includes(element?.id)) {
        selectedSubCategory.value.push(element?.id);
      }
    });
  }
};

const onClickAllCertificates = (event: any) => {
  const isChecked = event.target.checked;
  if (isChecked)
    selectedCertificate.value = certificates.value.map(
      (certificate: any) => certificate
    );
  else selectedCertificate.value = [];
};

const onClickCancel = () => {
  emits("onClickCancel");
};

const onClickContinue = async () => {
  if (!selectedSubCategory.value.length) {
    displayToastMessage(internalInstance, `select Services`, "info");
    return;
  }
  if (!selectedCertificate.value) {
    displayToastMessage(internalInstance, `select Certificates`, "info");
    return;
  }
  try {
    isLoading.value = true;
    const map = new Map();
    const categories: any = [];

    selectedSubCategory.value.forEach((subId: any) => {
      const categoryId = listOfSpecialismsCategory.value.find(
        (mainCategory: any) =>
          mainCategory.subCategories.some((subObj: any) => subObj.id === subId)
      ).id;
      map.set(categoryId, [
        ...(map.has(categoryId) ? map.get(categoryId) : []),
        {
          subcategoryId: subId,
        },
      ]);
    });
    map.forEach((subcategories, categoryId) => {
      categories.push({ categoryId, subcategories });
    });

    const certificatesData = selectedCertificate.value.map(
      (crt: any) => crt.id
    );
    if (!isAlreadyLink.value) {
      //update Link
      await store.dispatch(`${WORKSTATION}/createWorkStationLink`, {
        userId: user.value?.id,
        userWorkstationId: activeUserWorkstation.value?.id,
        certificates: certificatesData,
        services: JSON.stringify(categories),
      });
    } else {
      //update Link
      await store.dispatch(`${WORKSTATION}/updateWorkStationLink`, {
        linkId: activeUserWorkstation.value?.workstationLinkTree.id,
        data: {
          userId: user.value?.id,
          userWorkstationId: activeUserWorkstation.value?.id,
          certificates: certificatesData,
          services: JSON.stringify(categories),
        },
      });
    }
    emits("onClickCancel", true);
  } catch (e) {
    console.log("Error", e);
  } finally {
    isLoading.value = false;
  }
};

const debouncedCategoryFilter = (event: any) => {
  let debounceTimeOut;
  const search = event?.target?.value || "";
  clearTimeout(debounceTimeOut);
  debounceTimeOut = setTimeout(() => {
    if (search) {
      const searchTerm = search.toLowerCase();
      filterCategory.value = listOfSpecialismsCategory.value.filter(
        (category: any) => {
          const mainCategoryMatch = category.poLabel
            .toLowerCase()
            .includes(searchTerm);

          if (mainCategoryMatch) {
            return true;
          }
          const subCategoryMatch = category.subCategories?.some(
            (subCategory: any) =>
              subCategory.label.toLowerCase().includes(searchTerm)
          );

          return subCategoryMatch;
        }
      );
    } else {
      filterCategory.value = listOfSpecialismsCategory.value;
    }
  }, 300);
};

const debouncedCertificateFilter = (event: any) => {
  let debounceTimeOut;
  const search = event?.target?.value || "";
  clearTimeout(debounceTimeOut);
  debounceTimeOut = setTimeout(() => {
    if (search) {
      const searchTerm = search.toLowerCase();
      filterCertificates.value = certificates.value.filter(
        (certificate: any) => {
          return certificate.name.toLowerCase().includes(searchTerm);
        }
      );
    } else {
      filterCertificates.value = certificates.value;
    }
  }, 300);
};

const getAllSpecialism = computed(
  () => store.getters[`${USER_STORE}/getAllSpecialism`]
);
const userSpecialisms = computed(
  () => store.getters[`${USER_STORE}/userSpecialisms`]
);
const certificates = computed(() => {
  return store.getters[`${USER_STORE}/userCertificates`]?.map(
    (data: any) => data?.certificate
  );
});

const selectedServices = computed(() => {
  return (
    mainSelectedCategory.value
      .map((cat: any) => cat.poLabel)
      .slice(0, 3)
      .join(", ") + (mainSelectedCategory.value.length > 3 ? "..." : "")
  );
});

const isAlreadyLink = computed(() => {
  return activeUserWorkstation.value?.workstationLinkTree ? true : false;
});

const selectedWorkStationLinkData = () => {
  const workStationLinkTreeData =
    activeUserWorkstation.value?.workstationLinkTree;

  if (!workStationLinkTreeData) return;
  const workStationCertificates = workStationLinkTreeData.certificates;
  const workStationServices = JSON.parse(workStationLinkTreeData.services);

  certificates.value.forEach((crt: any) => {
    if (workStationCertificates.includes(crt?.id.toString())) {
      selectedCertificate.value.push(crt);
    }
  });
  if (selectedCertificate.value.length === certificates.value.length) {
    selectAllCertificates.value = true;
  }

  //services
  workStationServices?.forEach((service: any) => {
    service.subcategories.forEach((subCategory: any) => {
      selectedSubCategory.value.push(Number(subCategory.subcategoryId));
    });
  });
  sanitizationInMainCategory();
};
const onChangeCertificate = () => {
  if (certificates.value.length !== selectedCertificate.value.length) {
    selectAllCertificates.value = false;
  } else {
    selectAllCertificates.value = true;
  }
};
const sanitizationInMainCategory = () => {
  mainSelectedCategory.value = [];

  listOfSpecialismsCategory.value.forEach((specialism: any) => {
    const isAllSubcategorySelected = specialism.subCategories.every(
      (category: any) => selectedSubCategory.value.includes(category.id)
    );
    if (
      isAllSubcategorySelected &&
      !mainSelectedCategory.value.find((cat: any) => cat?.id === specialism.id)
    ) {
      mainSelectedCategory.value.push(specialism);
    }
  });
};

onMounted(() => {
  listOfSpecialismsCategory.value = userSpecialisms.value.map(
    (specialism: any) => {
      const category = specialism?.category;
      const subCategories = specialism?.subCategories;
      return {
        ...category,
        subCategories,
      };
    }
  );
  filterCategory.value = listOfSpecialismsCategory.value;
  filterCertificates.value = certificates.value;

  //selected Workstation data
  selectedWorkStationLinkData();
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_Text = _resolveComponent("Text")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(CommonDialog, {
    isShowHeader: false,
    isShowBackButton: false,
    width: "570px",
    "max-width": "100%",
    persistent: "",
    className: ['specialisms_multiselect_modal work_station_link_modal']
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h2", null, _toDisplayString(isAlreadyLink.value ? "Update a Link" : "Create a Link"), 1),
        _createVNode(_component_v_icon, {
          icon: "mdi-close",
          class: "close__icon",
          onClick: onClickCancel
        })
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (!isAlreadyLink.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, " Create a WorkStation Link Profile to share important details about your insurance plans, services offered, and contact information. Make it simple for clients and partners to connect and learn about your offerings in one convenient link. "))
            : (_openBlock(), _createElementBlock("p", _hoisted_5, " Update your WorkStation Link Profile to reflect the latest insurance plans, services, or updates. Keep your audience informed with accurate details to build trust and ensure seamless communication. "))
        ]),
        _createVNode(_component_v_expansion_panels, {
          modelValue: expandedPanel.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((expandedPanel).value = $event))
        }, {
          default: _withCtx(() => [
            _hoisted_6,
            _createVNode(_component_v_expansion_panel, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_expansion_panel_title, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      (!mainSelectedCategory.value.length)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Select Service"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(selectedServices.value), 1))
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_expansion_panel_text, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_v_text_field, {
                        variant: "outlined",
                        placeholder: "Search Services",
                        "prepend-inner-icon": "mdi-magnify",
                        onInput: debouncedCategoryFilter
                      })
                    ]),
                    (filterCategory.value.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createVNode(_component_v_expansion_panels, {
                            modelValue: panel.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((panel).value = $event)),
                            multiple: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterCategory.value, (specialism, index) => {
                                return (_openBlock(), _createBlock(_component_v_expansion_panel, { key: index }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_expansion_panel_title, null, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_12, [
                                          _createVNode(_component_v_checkbox, {
                                            color: "#4B4BFF",
                                            modelValue: mainSelectedCategory.value,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((mainSelectedCategory).value = $event)),
                                            value: specialism,
                                            onClick: ($event: any) => (onClickMainCategory(specialism.id))
                                          }, null, 8, ["modelValue", "value", "onClick"]),
                                          _createElementVNode("div", _hoisted_13, [
                                            (specialism.iconName)
                                              ? (_openBlock(), _createBlock(_component_v_icon, {
                                                  key: 0,
                                                  class: "specialisms_multiselect_modal_item_title_icon"
                                                }, {
                                                  default: _withCtx(() => [
                                                    (specialism.iconName)
                                                      ? (_openBlock(), _createElementBlock("img", {
                                                          key: 0,
                                                          style: {"width":"14px"},
                                                          src: 
                                require('@/assets/category-icons/' +
                                  specialism.iconName +
                                  '.svg')
                              ,
                                                          alt: "icon"
                                                        }, null, 8, _hoisted_14))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 2
                                                }, 1024))
                                              : _createCommentVNode("", true),
                                            _createElementVNode("div", _hoisted_15, [
                                              _createElementVNode("h2", null, _toDisplayString(specialism?.poLabel), 1),
                                              _createElementVNode("p", null, [
                                                _createTextVNode(_toDisplayString(specialism.subCategories
                                  .slice(0, 2)
                                  .map((sub) => sub.label)
                                  .join(", ")) + " ", 1),
                                                (specialism.subCategories?.length > 2)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, " etc.."))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ])
                                          ])
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true),
                    (!filterCategory.value.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _hoisted_20,
            _createVNode(_component_v_expansion_panel, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_expansion_panel_title, null, {
                  default: _withCtx(() => [
                    (!_unref(selectedCertificate).length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_21, "Select Certificate"))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedCertificate)?.slice(0, 3), (crt) => {
                      return (_openBlock(), _createElementBlock("p", {
                        key: crt.id
                      }, _toDisplayString(crt.name), 1))
                    }), 128))
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_expansion_panel_text, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_v_text_field, {
                        variant: "outlined",
                        placeholder: "Search Certification",
                        "prepend-inner-icon": "mdi-magnify",
                        onInput: debouncedCertificateFilter
                      })
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      (filterCertificates.value.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            _createVNode(_component_v_checkbox, {
                              color: "#4B4BFF",
                              modelValue: selectAllCertificates.value,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectAllCertificates).value = $event)),
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (onClickAllCertificates($event)))
                            }, null, 8, ["modelValue"]),
                            _hoisted_25
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_26, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterCertificates.value, (certificate) => {
                          return (_openBlock(), _createBlock(_component_v_checkbox, {
                            class: "tw-flex tw-gap-2 tw-my-2 tw-items-center tw-px-1",
                            key: certificate.id,
                            value: certificate,
                            label: certificate.name,
                            color: "#4B4BFF",
                            modelValue: _unref(selectedCertificate),
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(selectedCertificate) ? (selectedCertificate).value = $event : selectedCertificate = $event)),
                            onChange: onChangeCertificate
                          }, null, 8, ["value", "label", "modelValue"]))
                        }), 128))
                      ])
                    ]),
                    (!filterCertificates.value.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_29))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_30, [
          _createVNode(_component_v_btn, {
            class: "button button-purple-border",
            onClick: onClickCancel,
            block: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Text, { variant: "span" }, {
                default: _withCtx(() => [
                  _createTextVNode(" Cancel ")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_btn, {
            class: "button button-orange",
            block: "",
            onClick: onClickContinue,
            loading: isLoading.value
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Text, { variant: "span" }, {
                default: _withCtx(() => [
                  _createTextVNode(" CONTINUE ")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})